import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from '../../../../theme';
const hover = `
	color: ${theme.colors.BB100};
	.svg-default-foreground { color: ${theme.colors.BB100}; }
`;
const active = `
	color: ${theme.colors.BB100};

	.svg-active-foreground { color: ${theme.colors.BB100}; }
	.svg-active-background { color: ${theme.colors.BB10T}; }

	.svg-default-state { display: none; }
	.svg-active-state { display: initial; }
`;
export const StyledMenuBarCss = ({ highlighted }) => css `
	position: relative;
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	height: 100%;
	text-decoration: none;
	background: none;
	border: none;
	padding: 0;
	${theme.typography.IR80}
	line-height: ${theme.spacing.space40};
	cursor: pointer;
	color: ${theme.colors.BB200};

	svg { color: ${theme.colors.BB200}; }
	.svg-default-state { display: initial; }
	.svg-active-state { display: none; }

	${highlighted ? active : `&:hover {${hover}}`};
`;
export const StyledMenuBarLink = styled.a `${(c) => StyledMenuBarCss(c)}`;
export const StyledMenuBarButton = styled.button `${(c) => StyledMenuBarCss(c)}`;
//# sourceMappingURL=MenuBarItem.styled.js.map